import React from 'react'
import { connect } from 'react-redux'
import { Container } from './styled'
import { useNavigate, useParams } from "react-router-dom";
import { change, Field, getFormValues, reduxForm } from 'redux-form'
import TextInput from 'components/TailwindForm/TextInput'
import DateInput from 'components/TailwindForm/DateInput' // Assuming there's a DateInput component
import TextAreaInput from 'components/TailwindForm/TextAreaInput' // Assuming there's a TextAreaInput component
import FileInput from 'components/TailwindForm/FileInput' // Assuming there's a FileInput component
import StandardButton from 'components/Shareds/StandardButton'
import SelectInput from 'components/TailwindForm/SelectInput'
import { getTextResult, textKey } from 'core/textResult'
import RadioOnly from 'components/TailwindForm/RadioOnly';
import CheckBoxInput from 'components/TailwindForm/CheckBoxInput';
import { scrollToFirstValidateFailElement, fixJsonDate } from 'core/utilities'
import { validateField } from './helper';
import { Confirm } from 'semantic-ui-react'
import moment from 'moment'
import { SuccessPath } from 'routes';
import NumberInput from 'components/TailwindForm/NumberInput';
import TelInput from 'components/TailwindForm/TelInput';
import { formComplaint } from 'ducks/form';

const ComplaintForm = (props) => {
  const {
    valueForm,
    change,
    formComplaint
  } = props
  const history = useNavigate()
  const { id } = useParams()
  const actionName = React.useRef("");
  const [showError, setShowError] = React.useState("")
  const [checkPrivacy, setCheckPrivacy] = React.useState(false)
  const [showConfirmClear, setShowConfirmClear] = React.useState(false)
  const [showConfirmSubmit, setShowConfirmSubmit] = React.useState(false)

  const handleChange = (e, name) => {
    localStorage.setItem('language', name);
    window.location.reload()
  }
  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  React.useEffect(() => {
    if (!localStorage.getItem('language')) {
      localStorage.setItem('language', "en");
    }
    change('complaint_date', new Date())
  }, [])

  const oncheckPrivacy = (e, name) => {
    checkPrivacy == true ? setCheckPrivacy(false) : setCheckPrivacy(true)
  }
  const clearForm = () => {
    if (valueForm) {
      change('valueForm', null)
      props.reset('formComplaint')
      setCheckPrivacy(false)
      change('complaint_date', new Date())
    }
  }
  const confirmClear = () => {
    clearForm()
    setShowConfirmClear(false)
  }

  const onSubmitForm = () => {
    setShowConfirmSubmit(true)
  }
  const confirmSubmit = () => {
    formComplaint(valueForm, history)
    setShowConfirmSubmit(false)
  }
  const oncheckPrivacyNewTap = () => {
    if (localStorage.getItem('language') == "en") {
      openInNewTab("https://app.whitefact.co/external-privacy?id=2d1298e06b39414088be2b879e461388&lang=EN")
    } else {
      openInNewTab("https://app.whitefact.co/external-privacy?id=2d1298e06b39414088be2b879e461388&lang=TH")
    }
  }
  return (
    <Container className='App'>
      <div className='mt-10 lg:mt-10 '>
        <div className='flex text-center justify-center   lg:px-[400px]   2xl:px-[600px] items-center  '>
          <img src="/coverimage2.jpg" alt="logo" className="h-auto  w-full" />
        </div>
        <div className=' px-4 lg:px-[400px] 2xl:px-[600px]'>
          <div className=' py-5 flex flex-col'>
            <div className=' text-xl font-light   text-left  mb-2'>{getTextResult(textKey.TITLE)}</div>
            <div className='text-2xl flex flex-row  w-full'>
              <div className='w-1/2 font-bold  text-left text-xl lg:text-2xl whitespace-nowrap'>
                {getTextResult(textKey.TITLE1)}
              </div>
              <div className=' mx-2 flex w-1/2 justify-end  items-center font-light'>
                <span className='mr-2 text-base lg:text-xl'> {getTextResult(textKey.LANGUAGE)}</span>

                <button className={` ${localStorage.getItem('language') == "en" ? "bg-[#FCC652] " : "  border border-grey hover:border-transparent "}  font-sukhumvit text-sm text-black py-1 px-3  rounded  mr-2`} onClick={(e) => handleChange(e, "en")} >ENG</button>
                <button className={` ${localStorage.getItem('language') == "th" ? "bg-[#FCC652]" : "  border border-grey hover:border-transparent "}  font-sukhumvit text-sm text-black  py-1 px-3  rounded `} onClick={(e) => handleChange(e, "th")} >ไทย</button>

              </div>

            </div>
          </div>
          <div className='py-5 space-y-5 border-gray-200 border rounded-lg'>
            <div className='flex w-full px-3  font-bold text-sm'>
              {getTextResult(textKey.FORM1)}
            </div>
            <Field
              label={getTextResult(textKey.FORM2)}
              name='complaint_date'
              component={DateInput}
              editable={true}
              require
              disabled={true}
            />
            <Field
              label={getTextResult(textKey.FORM19)}
              name='complaints'
              component={TextInput}
              editable={true}
              maxLength={250}
              require
            />
            <Field
              label={getTextResult(textKey.FORM3)}
              name='type_complaints'
              editable={true}
              require
              component={SelectInput}
              optionsData={[
                { text: getTextResult(textKey.OPTIONDATA1), value: getTextResult(textKey.OPTIONDATA1) },
                { text: getTextResult(textKey.OPTIONDATA2), value: getTextResult(textKey.OPTIONDATA2) },
                { text: getTextResult(textKey.OPTIONDATA3), value: getTextResult(textKey.OPTIONDATA3) },
                { text: getTextResult(textKey.OPTIONDATA4), value: getTextResult(textKey.OPTIONDATA4) },
              ]}
            />

            <Field
              label={getTextResult(textKey.FORM4)}
              name='project_or_location'
              component={TextInput}
              editable={true}
              maxLength={250}
              require
            />

            <Field
              label={getTextResult(textKey.FORM5)}
              name='complaint_to_agency'
              component={TextInput}
              editable={true}
              maxLength={250}

            />

            <Field
              label={getTextResult(textKey.FORM6)}
              name='complaint_to_personal'
              component={TextInput}
              editable={true}
              maxLength={250}
              placeHolder={""}
            />

            <Field
              label={getTextResult(textKey.FORM7)}
              name='date_of_incident'
              component={DateInput}
              editable={true}
              placeHolder={getTextResult(textKey.TEXTAREA1)}
              maxDate={new Date()}
            />

            <Field
              label={getTextResult(textKey.FORM8)}
              name='detail_complaint'
              component={TextAreaInput}
              editable={true}
              maxLength={1000}
              require
              placeHolder={getTextResult(textKey.TEXTAREA)}
            />

            <Field
              label={getTextResult(textKey.FORM9)}
              label2={getTextResult(textKey.FORM20)}
              name='sender_attachments'
              component={FileInput}
              editable={true}
              multiple
            />
            <div className='text-left px-3  mt-1'>
              {getTextResult(textKey.FORM10)}
            </div>
            <div className='text-lg text-left px-3 '>
              <span className='font-bold'> {getTextResult(textKey.FORM11)}
              </span>
              <span className='ml-1'>  {getTextResult(textKey.FORM12)}
              </span>
              <div>
                {getTextResult(textKey.FORM13)}
              </div>
            </div>

            <div className='lg:flex lg:space-x-5 space-y-5 lg:space-y-0'>
              <Field
                label={getTextResult(textKey.FORM14)}
                name='sender_first_name'
                component={TextInput}
                editable={true}
                maxLength={250}
                require
              />
              <Field
                label={getTextResult(textKey.FORM15)}
                name='sender_last_name'
                component={TextInput}
                editable={true}
                maxLength={250}
                require
              />
            </div>

            <div className='lg:flex lg:space-x-5 space-y-5 lg:space-y-0'>
              <Field
                label={getTextResult(textKey.FORM16)}
                name='sender_email'
                component={TextInput}
                editable={true}
                maxLength={250}
                require
                showError={showError}
              />

            </div>
            <div className='lg:flex lg:space-x-5 space-y-5 lg:space-y-0'>
              <Field
                label={getTextResult(textKey.FORM17)}
                name='sender_mobile_no'
                component={TelInput}
                editable={true}
                require
              />

            </div>

          </div>
          <div className='flex lg:flex-row '>

            <div className='w-full flex flex-row justify-center  text-sm lg:text-lg my-4  text-[#64748B] text-left '>
              <Field
                name='type'
                component={CheckBoxInput}
                onChange={(e, value) => oncheckPrivacy(true)}
              // onChange={(e) => setAgree(e)}

              />
              <div className=''>
                <span className='text-[#FCC652] underline  cursor-pointer' onClick={() => oncheckPrivacyNewTap()} >
                  Privacy Notice
                </span> <span className='text-red-500'>
                  *
                </span> {getTextResult(textKey.FORM18)}
              </div>
            </div>
          </div>
          <div className='mt-2 flex flex-row w-full space-x-4'>
            <form onSubmit={props.handleSubmit(() => onSubmitForm())} className='w-1/2' >
              <div className='w-full'>
                <StandardButton disabled={!checkPrivacy} submit onClick={() => actionName.current = 'save'} label={getTextResult(textKey.SUBMIT)} customStyle={`${checkPrivacy ? "bg-[#FCC652]" : "bg-gray-300"} w-full  py-8 px-2   focus:outline-none  `} />
              </div>
            </form>
            <div className='w-1/2'>
              <StandardButton onClick={() => setShowConfirmClear(true)} label={getTextResult(textKey.CANCEL)} customStyle='  py-8 px-2 text-black border border-gray-300 focus:outline-none w-full' />
            </div>

          </div>


        </div>

      </div>
      <Confirm
        size='tiny'
        open={showConfirmSubmit}
        header={getTextResult(textKey.CONFIRMTITLE)}
        content={getTextResult(textKey.CONFIRMSUBMIT)}
        onCancel={() => setShowConfirmSubmit(false)}
        onConfirm={() => confirmSubmit()}
        confirmButton={getTextResult(textKey.OK)}
        cancelButton={getTextResult(textKey.CANCEL)}
      />
      <Confirm
        size='tiny'
        open={showConfirmClear}
        header={getTextResult(textKey.CONFIRMTITLE)}
        content={getTextResult(textKey.CONFIRMCANCEL)}
        onCancel={() => setShowConfirmClear(false)}
        onConfirm={() => confirmClear()}
        confirmButton={getTextResult(textKey.OK)}
        cancelButton={getTextResult(textKey.CANCEL)}
      />
    </Container>
  )
}

const mapStateToProps = (state) => ({
  valueForm: getFormValues('formComplaint')(state),
})

const mapDispatchToProps = {
  change,
  formComplaint
}
const validate = (values) => {
  let errors = validateField(values)
  return errors
}


const ComplaintFormWrapper = reduxForm({
  form: 'formComplaint',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(ComplaintForm)

export default connect(mapStateToProps, mapDispatchToProps)(ComplaintFormWrapper)
